import { useTheme } from '@emotion/react'
import { useTranslation } from 'react-i18next'

import { Button, Flex, PaddingInset, Text } from '@cash-design-system/react'
import { ModalPortal } from '@cash-web/shared-feature-modal'

export const NoRemainingAllocationModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation()
  const { spacing } = useTheme()
  return (
    <ModalPortal onClose={onClose}>
      <Flex flexDirection="column" gap={spacing.xl}>
        <PaddingInset>
          <Flex flexDirection="column" gap={spacing.m}>
            <Text typography="titleBarPageTitle" color="textStandard" textAlign="center">
              {t('Decrease other distributions to increase this one', { context: 'modal title' })}
            </Text>
            <Text typography="body" textAlign="center">
              {t('Your paycheck distributions must add up to 100%', { context: 'modal text' })}
            </Text>
          </Flex>
        </PaddingInset>
        <Button size="large" onClick={onClose}>
          {t('Got it', { context: 'button text' })}
        </Button>
      </Flex>
    </ModalPortal>
  )
}
